<template>
  <member-info v-if="dialogVisible" :show.sync="dialogVisible" :data="memberInfo" title="给用户转账" @close="dialogClose" @submit="handleSubmit">
    <el-descriptions-item label="转入积分">
      <el-input v-model="wallet.transferPoint" type="number" class="max-width" placeholder="请输入要转入的积分数量" />
    </el-descriptions-item>
    <el-descriptions-item label="转入券">
      <el-input v-model="wallet.coupon" type="number" class="max-width" placeholder="请输入要转入的券数量" />
    </el-descriptions-item>
  </member-info>
  <!-- <el-dialog title="给用户转账" width="450px" :visible.sync="dialogVisible" append-to-body :fullscreen="device==='mobile'" @close="dialogClose">
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="avatar-container">
          <el-image :src="memberInfo.avatar" :preview-src-list="[memberInfo.avatar]" fit="cover" />
        </div>
      </el-col>
      <el-col :span="24">
        <el-descriptions :label-style="{fontWeight:600}" :column="1" :colon="false" size="medium" border>
          <el-descriptions-item label="ID">{{ memberInfo.id }}</el-descriptions-item>
          <el-descriptions-item label="昵称">{{ memberInfo.nickName }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ memberInfo.mobile }}</el-descriptions-item>
          <el-descriptions-item label="分享码">{{ memberInfo.shareCode }}</el-descriptions-item>
          <el-descriptions-item label="转入积分">
            <el-input v-model="wallet.transferPoint" type="number" class="max-width" placeholder="请输入要转入的积分数量" />
          </el-descriptions-item>
          <el-descriptions-item label="转入券">
            <el-input v-model="wallet.coupon" type="number" class="max-width" placeholder="请输入要转入的券数量" />
          </el-descriptions-item>
        </el-descriptions>
      </el-col>
    </el-row>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取　消</el-button>
      <el-button type="primary" @click="handleSubmit">确　定</el-button>
    </span>
  </el-dialog> -->
</template>

<script>
import { mapGetters } from 'vuex'
import { transferAssets } from '@/api/member'

export default {
  name: 'UserTransfer',
  components: {
    MemberInfo: () => import('@/components/MemberInfo')
  },
  props: {
    show: Boolean,
    memberInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false,
      wallet: {
        transferPoint: undefined,
        coupon: undefined,
        mobile: undefined
      }
    }
  },
  computed: mapGetters(['device']),
  watch: {
    show: {
      immediate: true,
      handler(value) {
        this.dialogVisible = value
      }
    }
  },
  methods: {
    dialogClose() {
      this.dialogVisible = false
      this.$emit('update:show', false)
    },
    handleSubmit() {
      if (!this.wallet.transferPoint && !this.wallet.coupon) return this.$message.warning('请输入要转账的积分或券')

      this.$confirm('请确认是否要转账给该用户？', '温馨提示', { type: 'warning' }).then(() => {
        this.wallet = Object.assign({}, this.wallet, {
          memberId: this.memberInfo.id,
          mobile: this.memberInfo.mobile
        })
        transferAssets(this.wallet).then(response => {
          if (response) {
            this.$message.success('转账成功')
            this.dialogClose()
          }
        }).catch(() => {})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .avatar-container {
    display: block;
    text-align: center;
    margin-bottom: 20px;
    .el-image {
      width: 132px;
      height: 132px;
      border-radius: 50%;
    }
  }
</style>
